import { render, staticRenderFns } from "./mbinfo.vue?vue&type=template&id=2741d0b2&scoped=true&"
import script from "./mbinfo.vue?vue&type=script&lang=js&"
export * from "./mbinfo.vue?vue&type=script&lang=js&"
import style0 from "./mbinfo.vue?vue&type=style&index=0&id=2741d0b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2741d0b2",
  null
  
)

export default component.exports